import {SelectDataProps} from 'shared/types/select-data';

interface PermissionSelectProps {
  name: string;
  permissions: SelectDataProps[];
}

const defaultPermissions = [
  {label: 'Todas', value: 'all'},
  {label: 'Listagem', value: 'findAll'},
  {label: 'Detalhes', value: 'findOne'},
  {label: 'Cadastrar', value: 'create'},
  {label: 'Atualizar', value: 'update'},
  {label: 'Remover', value: 'delete'},
];

const readOnlyPermissions = [
  {label: 'Todas', value: 'all'},
  {label: 'Listagem', value: 'findAll'},
  {label: 'Detalhes', value: 'findOne'},
];

const findAllPermissions = [
  {label: 'Todas', value: 'all'},
  {label: 'Listagem', value: 'findAll'},
];

export const companyPermissions: {[key: string]: PermissionSelectProps} = {
  companies: {
    name: 'Minha empresa',
    permissions: [{label: 'Configurar empresa', value: 'findOne'}],
  },
  products: {
    name: 'Produtos',
    permissions: [...defaultPermissions, {label: 'Promoções', value: 'sales'}],
  },
  additionalGroups: {
    name: 'Grupos de adicionais',
    permissions: defaultPermissions,
  },
  billings: {name: 'Faturas', permissions: readOnlyPermissions},
  categories: {name: 'Categorias', permissions: defaultPermissions},
  coupons: {name: 'Cupons', permissions: defaultPermissions},
  orders: {name: 'Pedidos', permissions: defaultPermissions},
  subCategories: {name: 'Sub categorias', permissions: defaultPermissions},
  printer: {
    name: 'Impressão',
    permissions: [
      {
        label: 'Configurar',
        value: 'settings',
      },
    ],
  },
};

export const cityPermissions: {[key: string]: PermissionSelectProps} = {
  cities: {
    name: 'Minha cidade',
    permissions: [{label: 'Configurar cidade', value: 'findOne'}],
  },
  ...companyPermissions,
  deliveryManBillings: {
    name: 'Faturas (Entregadores)',
    permissions: readOnlyPermissions,
  },
  addresses: {name: 'Endereços', permissions: defaultPermissions},
  companies: {name: 'Empresas', permissions: defaultPermissions},
  neighborhoods: {name: 'Bairros', permissions: defaultPermissions},
  notifications: {name: 'Notificações', permissions: defaultPermissions},
  users: {name: 'Usuário', permissions: defaultPermissions},
  baseAdditionals: {
    name: 'Base de adicionais',
    permissions: defaultPermissions,
  },
  baseAdditionalGroups: {
    name: 'Base de grupos de adicionais',
    permissions: defaultPermissions,
  },
  wallet: {
    name: 'Carteira',
    permissions: [{label: 'Adicionar bônus', value: 'addBonus'}],
  },
  deliveryMen: {name: 'Entregadores', permissions: defaultPermissions},
  invoices: {name: 'Notas Fiscais', permissions: findAllPermissions},
  couponRedemptions: {
    name: 'Cupons (Relatórios)',
    permissions: findAllPermissions,
  },
  whatsappDeliveryErrors: {
    name: 'Erros de confirmação',
    permissions: findAllPermissions,
  },
};

export const franchisePermissions: {[key: string]: PermissionSelectProps} = {
  ...cityPermissions,
  permissionGroups: {
    name: 'Grupo de permissões',
    permissions: defaultPermissions,
  },
  cities: {name: 'Cidades', permissions: defaultPermissions},
  cityBillings: {name: 'Faturas (Cidades)', permissions: defaultPermissions},
  logs: {name: 'Logs', permissions: defaultPermissions},
  paymentMethods: {
    name: 'Formas de pagamento',
    permissions: defaultPermissions,
  },
  segments: {name: 'Segmentos', permissions: defaultPermissions},
};
